/** Date-only project deadlines in the user's local calendar, never UTC. */
function localDate(value: Date): string {
  const year = value.getFullYear();
  const month = String(value.getMonth() + 1).padStart(2, '0');
  const day = String(value.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

function today(): Date {
  const value = new Date();
  value.setHours(0, 0, 0, 0);
  return value;
}

/** Turn a non-negative lead time into a date for the native date input. */
export function dueDateFromDays(value: string): string | null {
  if (value.trim() === '') return null;
  const days = Number(value);
  if (!Number.isInteger(days) || days < 0) return null;
  const due = today();
  due.setDate(due.getDate() + days);
  return localDate(due);
}

/** Calendar days between today and a date-only project deadline. */
export function daysUntilDue(value: string): number | null {
  if (!value) return null;
  const due = new Date(`${value}T00:00:00`);
  if (Number.isNaN(due.getTime())) return null;
  return Math.round((due.getTime() - today().getTime()) / 86_400_000);
}
